import { mdiEmailOutline, mdiPhoneOutline } from "@mdi/js"
import {
  validateContactValue,
  type ContactComparison,
} from "../../../../../../../_shared/_logic/contact-comparison"
import type { ContactPointReviewRow, ContactPointReviewDraft } from "../../../contract"
export const editorReason = (
  row: ContactPointReviewRow,
  draft: ContactPointReviewDraft,
): string | null =>
  !row.needsStep
    ? "Diese Zeile ist bereits abgeschlossen."
    : row.reviewKind === "delete_contact_point"
      ? "Eine Löschentscheidung enthält keinen bearbeitbaren neuen Kontaktwert."
      : !["append", "replace"].includes(draft.action)
        ? "Ignorierte Angaben werden nicht übernommen."
        : !["EMAIL", "MOBILE", "FIXED_LINE"].includes(row.contactPointKind)
          ? "Diese Kontaktart wird nicht in diesem Dialog bearbeitet."
          : null
export const validateDraft = (
  row: ContactPointReviewRow,
  draft: ContactPointReviewDraft,
): string | null =>
  !draft.action
    ? "Bitte wählen Sie eine Kontaktentscheidung aus."
    : row.reviewKind !== "delete_contact_point" && ["append", "replace"].includes(draft.action)
      ? validateContactValue(row.contactPointKind, draft.value ?? row.submittedContactValue)
      : null
export const comparison = (
  row: ContactPointReviewRow,
  draft: ContactPointReviewDraft,
  previous: boolean,
): ContactComparison => {
  const value = previous
    ? row.existingContactValue || row.deletionValueLabel
    : (draft.value ?? row.submittedContactValue)
  const origin = row.sourceLabel

  return {
    side: previous ? "Bisheriges Kontaktdatum" : "Neues Kontaktdatum",
    label: value ? `${row.contactPointKindLabel}: ${value}` : "Nicht hinterlegt",
    subLabel: [row.customerRoleLabel, row.customerLabel].filter(Boolean).join(": "),
    contactValue: value || "Nicht hinterlegt",
    name: row.customerLabel,
    role: row.customerRoleLabel,
    email: row.contactPointKind === "EMAIL" ? value : "",
    phone: ["MOBILE", "FIXED_LINE"].includes(row.contactPointKind) ? value : "",
    unit: `${row.addressLabel} · ${row.unitLabel}`,
    icon: row.contactPointKind === "EMAIL" ? mdiEmailOutline : mdiPhoneOutline,
    ...(!previous
      ? {
          origin,
          original: row.submittedContactValue,
          state: row.isResolved
            ? "Gespeichertes Ergebnis"
            : value !== row.submittedContactValue
              ? "Manuell korrigierter Entwurf"
              : "Übernahmeentwurf",
          hint:
            draft.action === "reject"
              ? "Wird nicht übernommen"
              : draft.action === "delete"
                ? "Kontakt wird entfernt"
                : undefined,
        }
      : {}),
  }
}
